export default "__VITE_ASSET___lh6WJAP__"